export enum EnumPhaseStatus {
  PreSale = 1,
  Production = 2,
  Delivered = 3,
  Cancelled = 4,
  Completed = 5,
}
